import { render, staticRenderFns } from "./Izmeni.vue?vue&type=template&id=4be5a962&"
import script from "./Izmeni.vue?vue&type=script&lang=js&"
export * from "./Izmeni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports